import { useForm } from 'react-hook-form';

import { TChannelForm } from '../types';

export const DEFAULT_VALUES: Partial<TChannelForm> = {
  uri: '',
  name: '',
  short_name: '',
  av_code: '',
  logo: null,
  language_id: '',
  parameters: {
    logo: '',
    enrichments: {
      advertising: false,
      logos: false,
      ocr: false,
      peoples: false,
      stt: false,
    },
  },
  audience_channel_source_id: null,
  economical_value_channel_source_id: null,
  backup_channel_id: null,
  country_code: '',
  parent_channel_id: '',
  region_code: null,
  subregion_code: null,
  scope: null,
  media_type: undefined,
  provider: undefined,
};

export function useBroadcastersDrawerFormState() {
  const form = useForm<TChannelForm>({
    mode: 'all',
    defaultValues: DEFAULT_VALUES,
  });

  return { form };
}
